/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="membershipDefinitions.module.ts" />

module Meevo.Plugins.MembershipDefinitions {
  class MembershipDefinitionsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
    // statically inject constructor resources
    static $inject = [
      "meevo.AppSettings",
      "$http",
      "meevo.components.common.DataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',

      "meevo.components.busy.BusyService",
      "$filter"];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected $http: angular.IHttpService,
      protected dataService: Meevo.Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $filter: angular.IFilterService) {

      super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
    }


    createContext(): void {
      let vm = this;
      vm.busyService.start();
      vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_EMPLOYEE).then(() => {
        vm.busyService.stop();
        vm.context = new MembershipDefinitionsContext(this.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$rootScope, vm.busyService);
        super.createContext();
        vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
        vm.context.deactivate = () => {
          vm.visualState = Model.MaintenanceFormVisualState.Search;
        }
        let empContext = vm.context;

        //empContext.isEmployee = true;
      }).catch(() => {
        vm.busyService.stop();
      });
    }
  }

  angular.module("meevo.plugins.membershipDefinitions")
    .controller("meevo.plugins.membershipDefinitions.MembershipDefinitionsController", MembershipDefinitionsController);
}